import React from 'react'
import { useTranslation } from 'react-i18next'

import EmailIcon from '../../assets/icons/comment.svg?react'
import PhoneIcon from '../../assets/icons/phone.svg?react'
import { OAuthButton } from '../OAuthButton'
import { AuthErrorBanner } from './AuthErrorBanner'
import { AuthMethodOption } from './AuthMethodOption'

interface LoginMethodSelectorProps {
  onSelectEmail: () => void
  onSelectPhone: () => void
  onSelectGoogle: () => void
  disabled?: boolean
  errorMessage?: string
}

export const LoginMethodSelector: React.FC<LoginMethodSelectorProps> = ({
  onSelectEmail,
  onSelectPhone,
  onSelectGoogle,
  disabled,
  errorMessage
}) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-1.5">
        <h1 className="text-[22px] font-semibold tracking-tight text-neutralBlack-900">
          {t('loginMethods.title', { ns: 'auth' })}
        </h1>
        <p className="text-[13.5px] leading-snug text-neutralBlack-500">
          {t('loginMethods.subtitle', { ns: 'auth' })}
        </p>
      </div>

      {errorMessage ? <AuthErrorBanner message={errorMessage} /> : null}

      <div className="flex flex-col gap-2.5">
        <AuthMethodOption
          variant="primary"
          icon={EmailIcon}
          label={t('loginMethods.email', { ns: 'auth' })}
          onClick={onSelectEmail}
          disabled={disabled}
        />

        <OAuthButton provider="google" onClick={onSelectGoogle} disabled={disabled} block />

        <AuthMethodOption
          icon={PhoneIcon}
          label={t('loginMethods.phone', { ns: 'auth' })}
          onClick={onSelectPhone}
          disabled={disabled}
        />
      </div>

      <p className="text-xs leading-relaxed text-neutralBlack-400">
        {t('loginMethods.legalDisclaimer', { ns: 'auth' })}
      </p>
    </div>
  )
}
